const PreviewInfosLoading = () => {

    return (
        <div
            className='previewInfosLoading'
            role='status'
            aria-live='polite'
            aria-label='Loading highlights'
            aria-busy='true'
            style={{
                position: 'relative',
                padding: '0px 20px',
            }}>
            <div>
                <div className='loading' style={{ padding: '20px', borderRadius: '10px', width: '100%', height: '50px' }} />
            </div>
            <div
                className='loading'
                style={{ 
                    position: 'relative', 
                    width: '100%', 
                    aspectRatio: '16/9', 
                    overflow: 'hidden',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    borderRadius: '10px',
                    margin: '8px 0px',
                }}
            />
            <div style={{ width: '100%' }}>
                <div className='loading previewInfosLoadingBody' style={{ padding: '20px', borderRadius: '10px', width: '100%', height: '70px' }} />
            </div>
        </div>

    );
};

export default PreviewInfosLoading;
